import React from 'react'

import Drawer from 'components/atoms/Drawer'
import Message from 'components/atoms/Intl/Message'
import Content from 'providers/Drawer/drawers/Notification/Content'
import Sider from 'providers/Drawer/drawers/Notification/Sider'

export enum NotificationDrawerTab {
  tasks = 'tasks',
  informations = 'informations',
}

function Notification() {
  return (
    <Drawer
      open
      helmetTitle={'word.notifications'}
      pageHeaderProps={{
        title: <Message value="word.notifications" />,
      }}
      sider={Sider}
      content={Content}
    />
  )
}

export default React.memo(Notification)
